import { useEffect, useState } from "react";
import useIsMobile from "../utils/detectDevice";
import { SwitchCompanyDropdown } from "./TopBar/Components/companyDropdown";
import { FlyoutProfile } from "./TopBar/Components/FlyoutProfile";
import { useAuthStore } from "../store";
import { useGetPlatformInfo } from "../queries/auth";
import { SwitchProduct } from "./TopBar/Components/SwitchPlatform";
import FlyoutNotification from "../modals/FlyoutNotification";

function MobileNavBar({
  routes,
}: {
  routes: {
    title: string;
    path: string;
    subRoute: string;
    shouldBeDisplayed: boolean;
  }[];
}) {
  const { accessToken } = useAuthStore();

  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [platformData, setPlatformData] = useState<any>(null);

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData);
    }
  }, [userPlatformData]);

  const accessiblePlatforms = Array.from(
    new Set(
      platformData
        ?.filter(
          (platform: any) =>
            platform.data.access && platform.platform !== "captable"
        )
        .map((platform: any) => platform.platform)
    )
  );

  const { isMobile } = useIsMobile(1024);
  return (
    <div className="sticky top-0 z-40 flex h-14 shrink-0 items-center gap-x-4 shadow-sm border-gray-200 sm:gap-x-6 bg-white">
      <div className="flex flex-1 gap-x-4 self-stretch justify-end lg:gap-x-6">
        <div className="flex items-center gap-x-2 lg:gap-x-6">
          <SwitchCompanyDropdown />
          {accessiblePlatforms.length > 0 && (
            <SwitchProduct data={platformData} />
          )}
          <FlyoutNotification />
          <FlyoutProfile
            profileImage={
              (platformData && platformData[0]?.profilePicUrl) || ""
            }
          />
        </div>
      </div>
    </div>
  );
}

export default MobileNavBar;
